module.exports = __webpack_public_path__ + "img/cloud-check.6646a398.svg";